import { marketingHead } from "@/lib/marketing/seo";
import { breadcrumbs, webPageOf } from "@/lib/marketing/ppl-schema";

export function signupHead() {
  const seo = {
    title: "Sign up: subscribe to PEOPLE AI Workforce online | PEOPLE AI Workforce",
    description:
      "Choose how many communities, add PEOPLE Core and every AI employee at $999 per community per month each, five or more for the price of five, and pay monthly with PEOPLE Core free or yearly with two months free. No setup fee, cancel any time.",
    path: "/v2/subscribe",
    imageAlt: "PEOPLE AI Workforce. The AI workforce for senior living",
  };
  const head = marketingHead({
    ...seo,
    schema: [webPageOf(seo), breadcrumbs({ name: "Subscribe", path: "/subscribe" })],
  });
  /* A direct link handed to a buyer, not a page the site sends people to. */
  return { ...head, meta: [...head.meta, { name: "robots", content: "noindex,nofollow" }] };
}
